import { RegisterTerminalModalJustifiSteps, RegisterTerminalModalStripeSteps } from '../hooks';
import { StepperProps } from '../types';
import { STRIPE_REGISTER_TERMINAL_STEPS_TITLES } from '../utils';
import { ConnectToNetwork } from './connect-to-wifi';
import { GeneratePairingCode, PairYourTerminal } from './pair-terminal';
import { InstallBattery, PlugInTerminal, TurnTerminalOn } from './power-up-terminals';

type StripeAllStepsProps = {
  goToBigBang?: () => void; // handler that takes you to the start of the flow from where this flow starts
  goToStep?: (step: RegisterTerminalModalStripeSteps | RegisterTerminalModalJustifiSteps) => void; // handler that takes you to the step in the flow
  goBack?: () => void; // handler that takes you back to the previous step
  onComplete: () => void; // handler that takes you to the next step in the flow
  onRegisterTerminal: () => void; // handler that takes you to the next step in the flow
  Stepper: React.FC<StepperProps>; // component that renders the stepper
  locationId?: string;
  stripeLocationId?: string;
  paymentsUrl: string | null;
};

export const StripeAllSteps = ({
  goToBigBang,
  goToStep,
  goBack,
  onComplete,
  onRegisterTerminal,
  Stepper,
  locationId,
  stripeLocationId,
  paymentsUrl,
}: StripeAllStepsProps) => {
  return (
    <>
      <Stepper
        components={{ Footer: () => null }}
        label={STRIPE_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalStripeSteps.InstallBattery].heading}
        id={RegisterTerminalModalStripeSteps.InstallBattery}
      >
        <InstallBattery goBack={goToBigBang} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={STRIPE_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalStripeSteps.PlugInTerminal].heading}
        id={RegisterTerminalModalStripeSteps.PlugInTerminal}
        parentId={RegisterTerminalModalStripeSteps.InstallBattery}
      >
        <PlugInTerminal goBack={goBack} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={STRIPE_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalStripeSteps.TurnTerminalOn].heading}
        id={RegisterTerminalModalStripeSteps.TurnTerminalOn}
        parentId={RegisterTerminalModalStripeSteps.InstallBattery}
      >
        <TurnTerminalOn goBack={goBack} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={STRIPE_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalStripeSteps.ConnectToNetwork].heading}
        id={RegisterTerminalModalStripeSteps.ConnectToNetwork}
        parentId={RegisterTerminalModalStripeSteps.TurnTerminalOn}
      >
        <ConnectToNetwork goBack={goBack} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={STRIPE_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalStripeSteps.GeneratePairingCode].heading}
        id={RegisterTerminalModalStripeSteps.GeneratePairingCode}
      >
        <GeneratePairingCode goBack={goBack} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={STRIPE_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalStripeSteps.PairYourTerminal].heading}
        id={RegisterTerminalModalStripeSteps.PairYourTerminal}
        parentId={RegisterTerminalModalStripeSteps.GeneratePairingCode}
      >
        <PairYourTerminal
          goBack={goBack}
          goToStep={goToStep}
          onSuccess={onComplete}
          onTerminalPaired={onRegisterTerminal}
          paymentsUrl={paymentsUrl ?? undefined}
          locationId={locationId}
          stripeLocationId={stripeLocationId}
        />
      </Stepper>
    </>
  );
};

StripeAllSteps.displayName = 'RegisterTerminalStripeStep';
